import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/acceleration-calculator',
  component: () => import('../../routes/AccelerationCalculator.svelte'),
  card: {
    id: 'acceleration-calculator',
    title: 'Acceleration Calculator',
    description:
      'Solve kinematic equations for acceleration. Enter any three of initial velocity, final velocity, acceleration, and time to find the fourth.',
    icon: 'speed',
    iconBgClass: 'bg-purple-50',
    iconTextClass: 'text-purple-600',
    href: '/acceleration-calculator',
    category: 'Physics & Science',
  },
  seo: {
    title: 'Acceleration Calculator – Solve Kinematic Equations | v = v₀ + at',
    description:
      'Free acceleration calculator using kinematic equations. Solve for any variable: initial velocity, final velocity, acceleration, or time. Includes displacement calculation.',
  },
};

export default meta;